import { Role } from '../constants/roles.constants';

const userIsAuthorized = (
  userRole: Role | undefined | null,
  allowedRoles: Role[],
): boolean => {
  if (!userRole) {
    return false;
  }
  return allowedRoles.includes(userRole);
};

export default userIsAuthorized;
